import React from 'react';
import { useNavigate } from 'react-router-dom';
import M2TLogo from '../../components/common/M2TLogo';

export default function InvestorHeader() {
  const navigate = useNavigate();

  return (
    <header className="w-full bg-black text-white px-6 py-4 ">
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={() => navigate('/')}
      >
        <M2TLogo className="w-14 h-14" />
        <span className="text-2xl font-semibold hidden sm:inline">Million2Trillion</span>
      </div>
    </header>
  );
}
